/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Nexata_List_Files_On_MessageInputs */

const es_tools_nexata_list_files_on_message = /** @type {(inputs: Tools_Nexata_List_Files_On_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listando archivos del mensaje...`)
};

const en_tools_nexata_list_files_on_message = /** @type {(inputs: Tools_Nexata_List_Files_On_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing message files...`)
};

/**
* | output |
* | --- |
* | "Listing message files..." |
*
* @param {Tools_Nexata_List_Files_On_MessageInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_nexata_list_files_on_message = /** @type {((inputs?: Tools_Nexata_List_Files_On_MessageInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Nexata_List_Files_On_MessageInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_nexata_list_files_on_message(inputs)
	return en_tools_nexata_list_files_on_message(inputs)
});
export { tools_nexata_list_files_on_message as "tools.nexata.list_files_on_message" }